import('./assets/css/customerquestion.scss');
const widgetCustomerQuestion = document.querySelectorAll('.wt-CustomerQuestion');

window.fireOnVisible(widgetCustomerQuestion, async(customerQuestionElem) => {
    await import('./assets/js/customerquestion.ts').then(({ CustomerQuestion }) => {
        const CustomerQuestionInstance = new CustomerQuestion(customerQuestionElem, {
            slidesPerView: 1.2,
            breakpoints: {
                600: {
                    slidesPerView: 2,
                    navigation: false
                },
                740: {
                    slidesPerView: 3,
                    navigation: true
                }
            }
        });
    });
});
